import React, { useEffect, useRef, createElement } from 'react';
export function HeroSection() {
  const videoRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/wgugu05rta.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(embedScript);
    const style = document.createElement('style');
    style.textContent = "wistia-player[media-id='wgugu05rta']:not(:defined) { background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/wgugu05rta/swatch'); display: block; filter: blur(5px); padding-top: 155.83%; }";
    document.head.appendChild(style);
    if (videoRef.current) {
      const player = document.createElement('wistia-player');
      player.setAttribute('media-id', 'wgugu05rta');
      player.setAttribute('aspect', '0.6417112299465241');
      videoRef.current.appendChild(player);
    }
    return () => {
      if (document.head.contains(playerScript)) document.head.removeChild(playerScript);
      if (document.head.contains(embedScript)) document.head.removeChild(embedScript);
      if (document.head.contains(style)) document.head.removeChild(style);
    };
  }, []);
  const scrollToForm = () => {
    document.getElementById('formulario')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-[#1B2A4A] text-white py-16 md:py-24 px-4" data-id="element-70">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center gap-12" data-id="element-71">
        <div className="flex-1 space-y-8" data-id="element-72">
          <img src="https://cdn.magicpatterns.com/uploads/q5KtwAzpnaTYgkmRFVaWbj/Logo_JDON_Blanco.png" alt="Juega Desde Otro Nivel Logo" className="h-12 w-auto" data-id="element-73" />

          <h1 className="text-4xl md:text-5xl font-bold leading-tight" data-id="element-74">
            El techo invisible que frena el crecimiento de tu negocio
          </h1>

          <div className="w-full rounded-xl overflow-hidden shadow-2xl" data-id="element-75">
            <div ref={videoRef} data-id="element-76" />
          </div>

          <div className="space-y-4 text-lg text-gray-200" data-id="element-77">
            <p data-id="element-78">Trabajas todo el día…</p>
            <br data-id="element-79" />
            <p data-id="element-80">pero tu negocio no crece al nivel que podría.</p>
            <br data-id="element-81" />
            <p data-id="element-82">Probablemente tienes fugas de tiempo y foco.</p>
          </div>

          <div className="space-y-3 pt-4" data-id="element-83">
            <p className="text-sm font-semibold uppercase tracking-wider text-gray-300" data-id="element-84">
              DESCARGA EL MAPA DE GESTIÓN DE TIEMPO
            </p>
            <button onClick={scrollToForm} className="bg-[#FF6B00] hover:bg-[#e66000] text-white font-bold py-4 px-8 rounded-lg text-lg transition-colors w-full md:w-auto shadow-lg" data-id="element-85">
              QUIERO MI MAPA
            </button>
          </div>
        </div>

        <div className="flex-1 w-full" data-id="element-86">
          <img src="https://cdn.magicpatterns.com/uploads/q9SaCzWqRD2sLUzLWbZePK/mapa_de_gestion_de_tiempo.jpg" alt="Mapa de gestión de tiempo" className="w-full rounded-xl shadow-2xl border border-white/10" data-id="element-87" />
        </div>
      </div>
    </section>;
}